import { Controller } from '@hotwired/stimulus'
import Clipboard from 'clipboard/dist/clipboard.min'

export default class extends Controller {
  connect() {
    this.clipboard = new Clipboard(this.element.querySelectorAll('.btn'))
  }

  disconnect() {
    this.clipboard?.destroy()
  }
}
